import React from 'react';

export default function MediaContainer({ tag, aspect = 'aspect-video', children }) {
  return (
    <div
      className={`media-wrapper w-full ${aspect} bg-[#0A0A0A] border border-[#1F1F1F] rounded-[2px] relative overflow-hidden group`}
      style={{ 
        cursor: 'default',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        transform: 'translateZ(0)'
      }}
    >
      <div className="absolute inset-0 border border-[#1A1A1A] pointer-events-none z-20" />
      <div className="media-zoom absolute inset-0 w-full h-full">
        {children}
      </div>
      <div className="absolute bottom-[1.25rem] left-[1.25rem] z-30 pointer-events-none text-[0.75rem] uppercase tracking-[0.1em] text-[rgba(255,255,255,0.85)] bg-[rgba(0,0,0,0.4)] px-[0.65rem] py-[0.35rem] backdrop-blur-[4px] rounded-[2px] border border-[rgba(255,255,255,0.1)]">
        {tag}
      </div>
    </div>
  );
}